/**
 * /forgot-password — запит посилання для нового пароля (ч.1073).
 *
 * Пароль у відкритому вигляді не зберігається, тож «нагадати» його не можна:
 * надсилаємо одноразове посилання (лист і Telegram, якщо підключено).
 * Відповідь однакова для будь-якого email — сторінка не видає, чи існує
 * такий обліковий запис.
 */
import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { requestPasswordReset } from '@/api/auth';
import { extractApiError } from '@/utils/extractApiError';

export default function ForgotPasswordPage() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [sentTo, setSentTo] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await requestPasswordReset(email.trim());
      setSentTo(email.trim());
    } catch (err) {
      setError(extractApiError(err, 'Не вдалося надіслати посилання. Спробуйте пізніше.'));
    } finally {
      setLoading(false);
    }
  }

  if (sentTo) {
    return (
      <div className="login">
        <form onSubmit={(e) => e.preventDefault()}>
          <h1>Перевірте пошту</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
            Якщо обліковий запис <strong>{sentTo}</strong> існує, ми надіслали
            на нього посилання, щоб задати новий пароль (і в Telegram, якщо
            його підключено). Посилання діє 30 хвилин і спрацьовує один раз.
          </p>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
            Не бачите листа — перевірте папку «Спам» або запросіть ще раз
            за кілька хвилин.
          </p>
          <p style={{ marginTop: '1rem', fontSize: '0.85rem', textAlign: 'center' }}>
            <Link to="/login">Повернутися до входу</Link>
          </p>
        </form>
      </div>
    );
  }

  return (
    <div className="login">
      <form onSubmit={onSubmit}>
        <h1>Відновлення пароля</h1>
        <p style={{ marginTop: 0, color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
          Вкажіть email облікового запису — надішлемо посилання, щоб задати
          новий пароль.
        </p>
        <div className="field">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            autoComplete="email"
            autoFocus
            required
          />
        </div>
        <button type="submit" className="primary" style={{ width: '100%' }}
          disabled={loading || !email.trim()}>
          {loading ? 'надсилання…' : 'надіслати посилання'}
        </button>
        {error && <div className="error">{error}</div>}
        <p style={{ marginTop: '1rem', fontSize: '0.85rem', textAlign: 'center' }}>
          <Link to="/login">Повернутися до входу</Link>
        </p>
      </form>
    </div>
  );
}
